import Http, { HttpError } from '@ourea/fetch'
// 路由
import router from '../../router'
// eslint-disable-next-line no-unused-vars
let baseUrl = '/api'
if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-const-assign
  baseUrl = '/api'
}
export const http = Http({
  config: {
    credentials: 'include',
    baseUrl: baseUrl || '/',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    timeout: 5000,
  },
})

export default (Vue, opt = {}) => {

  const CUSTOM_HTTP_ERROR_STATUS = 602 // 前端项目内自定义错误码

  http.setOption(opt)

  http.injectAfter(rsp => {
    try {
      const { success, code, message, msg, flag } = rsp
      if (!success || code === 40101) {
        if (code === 40101) { // 根据项目判断状态码
          return new HttpError({
            code,
            httpStatus: HttpError.ERROR_CODE.TOKEN_EXPIRE, // 登录超时
            message: message || msg || HttpError.HTTP_ERROR_MAP[HttpError.ERROR_CODE.TOKEN_EXPIRE],
          })
        } else if (code !== '0') {
          return new HttpError({
            code,
            httpStatus: CUSTOM_HTTP_ERROR_STATUS, // 服务器返回的错误
            message: message || msg || '后台返回未知错误',
          })
        }
      } else {
        if (flag === '7') {
          // console.log(this.$cookies)
          // if (this.$cookies.get('sid')) {
          //   this.$cookies.remove('sid')
          // }
          // this.$cookies.remove('sid')
          router.replace({
            path: '/login',
          })
        }
      }
    } catch (error) {
      return new HttpError({
        code: CUSTOM_HTTP_ERROR_STATUS,
        httpStatus: HttpError.ERROR_CODE.RESPONSE_PARSING_FAILED, // 解析数据错误
        message: HttpError.HTTP_ERROR_MAP[HttpError.ERROR_CODE.RESPONSE_PARSING_FAILED],
      })
    }
  })

  http.setErrorHook((httpError, fetchUrl) => {
    console.log('[HTTP ERROR]', fetchUrl, httpError) // eslint-disable-line
  })

  Vue.prototype.http = http
}
